import { createFileRoute } from '@tanstack/react-router'

import { DataExtractionSummary } from '@/widgets/data-extraction'

export const Route = createFileRoute(
  '/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId',
)({
  component: RouteComponent,
})

export const DataExtractionSummaryRoute = Route

function RouteComponent() {
  const { caseId, userClientId } = Route.useParams()

  return <DataExtractionSummary caseId={caseId} userClientId={userClientId} />
}
